import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Button } from 'semantic-ui-react'
// import _find from 'lodash/find';
import _ from 'lodash';
// import JsBarcode from 'jsbarcode';
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'

import codBarras from '../../../functions/codbarras'

import ImprFact from '../../../components/funcionales/imprfact'

import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import ListaZo from '../../../components/funcionales/dirmayor/listazo';
import ListaBa from '../../../components/funcionales/dirmayor/listaba';
import selDirmayor from '../../../functions/seldirmayor';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

// "use strict";

//dropdown ESTADOS
const DetalleNivelEst1 = props => {
  return (
    <option style={props.styles.input} value={props.elemento.estadoCli}>{props.elemento.estadoCli}</option>
  )
};

const ListaEst = ({styles, handleChange, list, argsDocum}) => {
  const Nivel1Detalle = list.map((elemento, i) => <DetalleNivelEst1 styles={styles} elemento={elemento} key={i} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="estadoCli" id="miLista6" value={argsDocum.estadoCli} onChange={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown ESTADOS

//dropdown PROCESOS DE FACT
const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.observaciones} dato2={props.elemento.codProcFact}
        value={props.elemento._id} style={props.styles.input}>{props.elemento.descrDpto} ={">"} {props.elemento.nombreCiudad} ={">"} {props.elemento.descrClaseServ} ={">"} RANGO: {props.elemento.factInicial} - {props.elemento.factFinal} ={">"} CICLO: {props.elemento.cicloFact}</option>
  )
};

const Lista = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="proceso" id="miListaP"  onChange={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown PROCESOS DE FACT

//Lista de facturas
const FactCli = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.numeroFra}</td>
      <td className=''>{elemento.contrato}</td>
      <td className=''>{elemento.nombreBarrio}</td>
      <td className=''>{elemento.fechaFact.substr(0, 10)}</td>
      <td className=''>{elemento.agno}</td>
      <td className=''>{elemento.mes}</td>
      <td className='right aligned'>{elemento.valorAntesImptos}</td>
      <td className='right aligned'>{elemento.valorFacturado}</td>
      <td className='right aligned'>{elemento.valorFactura}</td>
    </tr>
  )
};

const ListaFact = ({list}) => {
  const nivel1Detalle = list.map((elemento, _id) => <FactCli elemento={elemento} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

// const fechaHoy = new Date()
// let agnoHoy = fechaHoy.getFullYear()
// let mesHoy = ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1))
// let fechaHoy = new Date()
// // let fechaIni = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-01'
// fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

class FactIFact2 extends React.Component {
  state={argsDocum: {mes: "", saldoPendiente: 0, checkEnvFraCorreo: false, checkSaldoPendiente: false,
        diasMora: 0, checkMora: false, desdeF: this.props.fechaIni,
        hastaF: "", estadoCli: "Todos..."}, totFras: 0, listFact: [],
        printFras: "uno", stImprFact: false, clientesFra: [], argsSelDpto: this.props.argsSelDpto,
        observaciones: "", confirmaAct: false, open: false, errors: []}

  handleChange = (ev) => {
    // console.log(ev.target.name)
    // console.log(ev.target.value)
    // console.log(ev.target.checked)
    if(ev.target.name==="imprimir"){
      if(ev.target.checked===true){
        this.setState({printFras: ev.target.value})
      }
    }else{
      if(ev.target.name==="proceso"){
        var miLista = document.getElementById("miListaP");
        this.setState({observaciones: miLista.options[miLista.selectedIndex].attributes[0].value})
      }else{
        // if(ev.target.name==="mes"){
        //   this.setState({observaciones: ""})

        //   let argsBuscarFact={}
        //   argsBuscarFact.agno = ev.target.value.substr(0, 4)
        //   argsBuscarFact.mes = ev.target.value.substr(5, 2)
        //   this.props.allFacturacion.refetch(argsBuscarFact)
        // }
        const argsDocum = this.state.argsDocum
        if(ev.target.name==="estadoCli"){
          let miLista = document.getElementById("miLista6");
          argsDocum[ev.target.name] = miLista.options[miLista.selectedIndex].text
        }else{
          // if(ev.target.name === "checkSaldoPendiente"||ev.target.name === "checkDiasMoraFin"){
          if(ev.target.name === "checkSaldoPendiente"||ev.target.name === "checkMora"||
              ev.target.name === "checkEnvFraCorreo"){
            argsDocum[ev.target.name] = ev.target.checked
          }else{
            argsDocum[ev.target.name] = ev.target.value
          }
        }
        let listFact = []
        this.setState({argsDocum, listFact})
      }
    }
    this.setState({stImprFact: false})
  }

  handleSubmit = async (ev, argsDocum)=>{
    let archPdf = ev.target.name
    
    // console.log(this.props.list)
    // console.log(this.props.list2)
    // console.log(this.props.allFacturacion.allFacturacion)
    document.body.style.cursor = 'wait'
    if(!this.props.list||!this.props.list2||!this.props.allFacturacion.allFacturacion){
      archPdf = "nohaydatos"
      console.log("cargando...")
      // alert("Proceso de cargue de la información, por favor espere un momento...")
    }
    let errors = []
    if(!argsDocum.desdeF){
      errors.push({path: "Desde", message: "Debe seleccionar la fecha inicial de procesos de facturación"});
    }
    if(!argsDocum.hastaF){
      errors.push({path: "Hasta", message: "Debe seleccionar la fecha final de procesos de facturación"});
    }
    this.setState({errors})
    if(errors.length===0){
      let clientesFra = []
      // let argsBuscarCL = this.props.argsBuscar
      let argsBuscarCL = {}
      argsBuscarCL.descrDpto=null
      argsBuscarCL.nombreCiudad=null
      argsBuscarCL.nombreZona=null
      argsBuscarCL.nombreBarrio=null

      // console.log(argsBuscarCL)
      if(!argsBuscarCL.contrato){
        argsBuscarCL.contrato=null
      }
      if(!argsBuscarCL.estadoCliente){
        argsBuscarCL.estadoCliente=null
      }
      // console.log(argsBuscarCL)
      // console.log(this.props.argsBuscar)
      // console.log(this.props.args)
      // console.log(argsDocum)

      // if(this.props.allCliBasico.allCliBasico){
      //   let {data} = await this.props.allCliBasico.refetch(argsBuscarCL)
      //   clientesFra = data.allCliBasico
      // }
      // console.log(clientesFra)

      let listFact = [], listFactTemp = []
      if(archPdf!=="nohaydatos"&&archPdf!=="pdf"){
        var miLista = document.getElementById("miListaP");
        // let proceso = miLista.options[miLista.selectedIndex].attributes[1].value

        const argsBuscarFact = {fechaMov: { $gte: argsDocum.desdeF, $lte: argsDocum.hastaF }, tipoGen: "proceso"}
        if(miLista.options[miLista.selectedIndex].text!=="Todos..."){
          argsBuscarFact.codProcFact = miLista.options[miLista.selectedIndex].attributes[1].value
        }else{
          argsBuscarFact.codProcFact = null
        }
        // console.log(argsBuscarFact)
        if(this.props.allFacturacion.allFacturacion){
          // argsBuscarFact.numeroFra = "onepay"
          // console.log(argsBuscarFact)
          let {data} = await this.props.allFacturacion.refetch(argsBuscarFact)
          // console.log(this.props.allFacturacion.allFacturacion)
          listFactTemp = await data.allFacturacion
        }

        //filtrar por dpto, ciudad, zona, barrio
        if(!this.state.argsSelDpto.descrDpto||this.state.argsSelDpto.descrDpto==="Todos..."){
          // listFactTemp = listFactTemp
        }else{
          if(!this.state.argsSelDpto.nombreCiudad||this.state.argsSelDpto.nombreCiudad==="Todas..."){
            argsBuscarCL.descrDpto=this.state.argsSelDpto.descrDpto

            listFactTemp = listFactTemp.filter(elemento => 
              elemento.descrDpto===this.state.argsSelDpto.descrDpto)
          }else{
            if(!this.state.argsSelDpto.nombreZona||this.state.argsSelDpto.nombreZona==="Todas..."){
              argsBuscarCL.descrDpto=this.state.argsSelDpto.descrDpto
              argsBuscarCL.nombreCiudad=this.state.argsSelDpto.nombreCiudad

              listFactTemp = listFactTemp.filter(elemento => 
                elemento.descrDpto===this.state.argsSelDpto.descrDpto&&
                elemento.nombreCiudad===this.state.argsSelDpto.nombreCiudad)
            }else{
              if(!this.state.argsSelDpto.nombreBarrio||this.state.argsSelDpto.nombreBarrio==="Todos..."){
                argsBuscarCL.descrDpto=this.state.argsSelDpto.descrDpto
                argsBuscarCL.nombreCiudad=this.state.argsSelDpto.nombreCiudad
                argsBuscarCL.nombreZona=this.state.argsSelDpto.nombreZona

                listFactTemp = listFactTemp.filter(elemento =>
                  elemento.descrDpto===this.state.argsSelDpto.descrDpto&&
                  elemento.nombreCiudad===this.state.argsSelDpto.nombreCiudad&&
                  elemento.nombreZona===this.state.argsSelDpto.nombreZona)
              }else{
                argsBuscarCL.descrDpto=this.state.argsSelDpto.descrDpto
                argsBuscarCL.nombreCiudad=this.state.argsSelDpto.nombreCiudad
                argsBuscarCL.nombreZona=this.state.argsSelDpto.nombreZona
                argsBuscarCL.nombreBarrio=this.state.argsSelDpto.nombreBarrio

                listFactTemp = listFactTemp.filter(elemento =>
                  elemento.descrDpto===this.state.argsSelDpto.descrDpto&&
                  elemento.nombreCiudad===this.state.argsSelDpto.nombreCiudad&&
                  elemento.nombreZona===this.state.argsSelDpto.nombreZona&&
                  elemento.nombreBarrio===this.state.argsSelDpto.nombreBarrio)
              }
            }
          }
        }
        // console.log(argsBuscarCL)
        // let losdos = {...argsBuscarFact, ...argsBuscarCL}
        // console.log(losdos)

        // let listFactTempLosdos = []
        // if(this.props.allFacturacion.allFacturacion){
        //   let {data} = await this.props.allFacturacion.refetch(losdos)
        //   // console.log(this.props.allFacturacion.allFacturacion)
        //   listFactTempLosdos = await data.allFacturacion
        // }
        // console.log(listFactTempLosdos)

        if(this.props.allCliBasico.allCliBasico){
          let {data} = await this.props.allCliBasico.refetch(argsBuscarCL)
          clientesFra = await data.allCliBasico

          if(this.state.argsDocum.estadoCli!=="Todos..."&&this.state.argsDocum.estadoCli!=="DESCONECTADO, SUSPENDIDO o RETIRADO"){
            clientesFra = clientesFra.filter(elemento =>
              elemento.estadoCliente===this.state.argsDocum.estadoCli)
          }else{
            if(this.state.argsDocum.estadoCli==="DESCONECTADO, SUSPENDIDO o RETIRADO"){
              clientesFra = clientesFra.filter(elemento =>
                elemento.estadoCliente==='DESCONECTADO'||elemento.estadoCliente==='SUSPENDIDO'||
                elemento.estadoCliente==='RETIRADO')
            }
          }
        }
        // console.log(clientesFra)

        // console.log(listFactTemp)
        // console.log(this.props.allFacturacion.allFacturacion)
        listFactTemp = listFactTemp.filter(factura => factura.codProcFact!=="ANULADA")

        if(miLista.options[miLista.selectedIndex].text==="Todos..."){
          // listFactTemp = listFactTemp.filter(factura =>
          //   factura.agno===mesMsg.substr(0, 4)&&factura.mes===mesMsg.substr(5, 2)&&
          //   factura.codProcFact!=="ANULADA")
        }else{
          // listFactTemp = listFactTemp.filter(factura => factura.codProcFact===proceso)
        }
        listFactTemp = _.orderBy(listFactTemp, ['nombreBarrio', 'direccion'], ['asc', 'asc'])
        // var imgSource
        // listFactTemp.forEach(async (elemento, ii) => {
          // let iii = 0
          // console.log(argsDocum.checkSaldoPendiente, argsDocum.checkMora)
        for(let ii=0; ii<listFactTemp.length; ii++){
          let elemento = listFactTemp[ii]

          let indexSearchC = 0
          if(argsDocum.checkSaldoPendiente||argsDocum.checkMora||!argsDocum.checkEnvFraCorreo){
            if(argsDocum.checkSaldoPendiente){
              indexSearchC = clientesFra.findIndex( cliente => cliente.contrato===elemento.contrato&&
                cliente.saldoPendiente>argsDocum.saldoPendiente )
            }
            if(argsDocum.checkMora&&indexSearchC!==-1){
              indexSearchC = clientesFra.findIndex( cliente => cliente.contrato===elemento.contrato&&
                cliente.diasMora<=argsDocum.diasMora )
            }  
            if(!argsDocum.checkEnvFraCorreo&&indexSearchC!==-1){
              indexSearchC = clientesFra.findIndex( cliente => cliente.contrato===elemento.contrato&&
                cliente.envFraCorreo==="N" )
            }
          }else{
            indexSearchC = clientesFra.findIndex( cliente => cliente.contrato===elemento.contrato )
          }
          if(indexSearchC!==-1){
            // //PARA IMPRIMIR CODIGO DE BARRAS
            //           let factCodBarras = ""
            //           if(this.props.empresa.modeloCodBarras==="1"){
            //             //ultimo caracter=longitud del prefijo
            //             //=> la referencia queda =>  prefijo factura + numero factura + longitud prefijo factura
            //               //queda de 10 digitos => se completa con ceros a la izquierda            
            //             let posic1 = elemento.numeroFra.indexOf("-")
            //             if(posic1===-1){
            //               factCodBarras = `${elemento.numeroFra}0`
            //             }else{
            //               factCodBarras = elemento.numeroFra.substr(posic1 + 1)      
            //               let prefijoFra = elemento.numeroFra.substr(0, posic1)
            //               let longPrefijo = prefijoFra.length
            //               factCodBarras = `${prefijoFra}${factCodBarras}${longPrefijo}`
            //             }
            //           }
            //           if(this.props.empresa.modeloCodBarras==="2"){
            //             factCodBarras = `${elemento.contrato}`
            //           }
            //       //slice => para extraer caracteres de la derecha
            //           let valorCodBarras = `00000000000000${factCodBarras}`
            //           // valorCodBarras = valorCodBarras.slice(-14)
            //           factCodBarras = valorCodBarras.slice(-10)
                  
            //           // factCodBarras = factCodBarras.slice(-24)

            //           // let valorCodBarras = `00000000000000${elemento.valorFactura}`
            //           // valorCodBarras = valorCodBarras.slice(-14)

            //           // console.log(elemento)
            //           let fechaCodBarras
            //           if(elemento.pagueHasta){
            //             fechaCodBarras = `${elemento.pagueHasta.substr(0,4)}${elemento.pagueHasta.substr(5,2)}${elemento.pagueHasta.substr(8,2)}`
            //           }else{
            //             fechaCodBarras = `${elemento.fechaFact.substr(0,4)}${elemento.fechaFact.substr(5,2)}${elemento.fechaFact.substr(8,2)}`
            //           }

            //           // factCodBarras =  `000000000000000000000000${elemento.numeroFra}`
            //           // factCodBarras = factCodBarras.slice(-10)
            //           valorCodBarras = `00000000000000${elemento.valorFactura}`
            //           // valorCodBarras = valorCodBarras.slice(-8)
            //           valorCodBarras = valorCodBarras.slice(-10)

            // // console.log(this.props.empresa, this.props.codBarrasRdo)
            //           // let textoCB = `Ê415${this.props.codBarrasRdo}8020${factCodBarras}Ê3900${valorCodBarras}Ê96${fechaCodBarras}`
            //           // let textoCBTxt = `(415)${this.props.codBarrasRdo}(8020)${factCodBarras}(3900)${valorCodBarras}(96)${fechaCodBarras}`
            //           let textoCB = `Ê415${this.props.codBarrasRdo}8020${factCodBarras}Ê3900${valorCodBarras}`
            //           let textoCBTxt = `(415)${this.props.codBarrasRdo}(8020)${factCodBarras}(3900)${valorCodBarras}`

            //           let canvas = document.createElement("canvas");
            //           // JsBarcode("#barcodecanvasjs", textoCB, {
            //           JsBarcode(canvas, textoCB, {
            //             format: "CODE128",
            //             ean128: true,
            //             text: textoCBTxt,
            //             lineColor: "#000000",
            //             width: 2,
            //             height: 50,
            //             // width: 2,
            //             // height: 50,
            //             displayValue: true
            //           });
            //           // let canvas = document.getElementById('barcodecanvasjs');
            //           let imgSource = canvas.toDataURL("image/png");
            // //FIN PARA IMPRIMIR CODIGO DE BARRAS
            // // console.log(textoCB)
            // console.log(elemento)
            let documFra = elemento
            let modeloCodBarras = this.props.empresa.modeloCodBarras
            // let codBarrasRdo = this.props.codBarrasRdo
            let codBarrasRdo = elemento.codBarrasRdo?elemento.codBarrasRdo:this.props.codBarrasRdo
            let imgSource = await codBarras(documFra, modeloCodBarras, codBarrasRdo)
            listFact.push({...elemento, codBarras: imgSource})
            // console.log(listFactTemp.length, ii)
            // if(listFactTemp.length===ii+1){
            //   console.log(listFact.length)
            //   this.setState({listFact, totFras: listFact.length, clientesFra})
            // }
          }
          // iii += 1
        }
        // })
        // console.log(listFactTemp.length, iii)
        // if(listFactTemp.length===iii){
        //   console.log(listFact.length)
          this.setState({listFact, totFras: listFact.length, clientesFra})
        // }
        // console.log(listFact)
      }
      if(archPdf==="pdf"&&this.state.listFact.length){
        this.setState({stImprFact: true})
      }else{
        this.setState({stImprFact: false})
      }
    }
    document.body.style.cursor = 'default'
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }

  handleSubmitCsv = async (ev, argsDocum) => {
    // console.log(this.props.empresa.empresaArchFE)
    const response = await this.props.fecha({
      variables: {}
    });
    const {fechaFechaHoy} = await response.data.fecha
    let fechaImpr = fechaFechaHoy.substr(0,10)

    // console.log(fechaImpr)

    let errors = []

    if(!this.props.allFactRtes.allFactRtes){
      errors.push({path: "Facturas", message: "Proceso de cargue de la información, por favor espere un momento..."});
    }
    if(!argsDocum.desdeF){
      errors.push({path: "Desde", message: "Debe seleccionar la fecha inicial de procesos de facturación"});
    }
    if(!argsDocum.hastaF){
      errors.push({path: "Hasta", message: "Debe seleccionar la fecha final de procesos de facturación"});
    }
    this.setState({errors})
    if(errors.length===0){
      let nombreArch = "facturacion.csv"
      document.body.style.cursor = 'wait'
      let listFactCsv = []
      var miLista = document.getElementById("miListaP");
      let argsBuscarFact = `fechaMov: {$gte: new Date('${argsDocum.desdeF}'), $lte: new Date('${argsDocum.hastaF}')}, tipoGen: "proceso", codProcFact: {$ne: "ANULADA"},`
      if(miLista.options[miLista.selectedIndex].text!=="Todos..."){
        argsBuscarFact += `'codProcFact': '${miLista.options[miLista.selectedIndex].attributes[1].value}'`
      }

      if(!this.state.argsSelDpto.descrDpto||this.state.argsSelDpto.descrDpto==="Todos..."){

      }else{
        if(!this.state.argsSelDpto.nombreCiudad||this.state.argsSelDpto.nombreCiudad==="Todas..."){
          argsBuscarFact += `'descrDpto': '${this.state.argsSelDpto.descrDpto}',`
        }else{
          nombreArch = "f" + this.state.argsSelDpto.codigoCiudadInterno + this.props.empresa.prefijoServ + ".csv"
          if(!this.state.argsSelDpto.nombreZona||this.state.argsSelDpto.nombreZona==="Todas..."){
            argsBuscarFact += `'descrDpto': '${this.state.argsSelDpto.descrDpto}',`
            argsBuscarFact += `'nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}',`
          }else{
            if(!this.state.argsSelDpto.nombreBarrio||this.state.argsSelDpto.nombreBarrio==="Todos..."){
              argsBuscarFact += `'descrDpto': '${this.state.argsSelDpto.descrDpto}',`
              argsBuscarFact += `'nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}',`
              argsBuscarFact += `'nombreZona': '${this.state.argsSelDpto.nombreZona}',`
            }else{
              argsBuscarFact += `'descrDpto': '${this.state.argsSelDpto.descrDpto}',`
              argsBuscarFact += `'nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}',`
              argsBuscarFact += `'nombreZona': '${this.state.argsSelDpto.nombreZona}',`
              argsBuscarFact += `'nombreBarrio': '${this.state.argsSelDpto.nombreBarrio}',`
            }
          }
        }
      }
      // console.log(argsBuscarFact)
      argsBuscarFact = '{' + argsBuscarFact + '}'
      let argsBuscarSP = ""
      if(!argsDocum.checkEnvFraCorreo){
        argsBuscarSP = `{$match: {envFraCorreo: "N", `
      }else{
        argsBuscarSP = `{$match: {`
      }
      if(argsDocum.checkSaldoPendiente&&argsDocum.checkMora){
        argsBuscarSP += `saldoPendienteCl: {$gt: ${argsDocum.saldoPendiente}}, diasMoraCl: {$lte: ${argsDocum.diasMora}}}},`
      }else{
        if(argsDocum.checkSaldoPendiente||argsDocum.checkMora){
          if(argsDocum.checkSaldoPendiente){
            argsBuscarSP += `saldoPendienteCl: {$gt: ${argsDocum.saldoPendiente}}}},`
          }
          if(argsDocum.checkMora){
            argsBuscarSP += `diasMoraCl: {$lte: ${argsDocum.diasMora}}}},`
          }
        }else{
          argsBuscarSP += `}},`
        }
      }
      // console.log(argsBuscarSP)
      let tipoqry = `[{$match: ${argsBuscarFact}},`
      argsBuscarFact = {tipoqry: `${tipoqry}
        {$unwind:"$detalleFact"},
        {$project: {_id1: '$_id', numeroFra: 1, fechaFact: 1, codProcFact: 1, codigoCiudadInterno: 1,
              contrato: 1, nombreCliente: 1, apellidoCliente: 1, direccion: 1, nombreBarrio: 1, nombreCiudad: 1,
              descripcionServicio: '$detalleFact.descripcionServicio',
              valorAntesDeIVA: {$toInt: {
                  $let: {
                      vars: {valorTipo: '$detalleFact.valor', tipo: '$detalleFact.tipo'},
                      in: { $cond: { if: { $eq: [ "$$tipo", "SF" ] }, then: "$$valorTipo", else: 0 } }
                  }
              }},
              valorIVA: {$toInt: {
                  $let: {
                      vars: {valorTipo: '$detalleFact.valor', tipo: '$detalleFact.tipo'},
                      in: { $cond: { if: { $eq: [ "$$tipo", "IF" ] }, then: "$$valorTipo", else: 0 } }
                  }
              }},
              periodo: '$detalleFact.periodo', totalFraAntesImptos: '$valorAntesImptos', totalFraDespuesImptos: '$valorFacturado',
              saldoPendiente: {$subtract: [ "$valorFactura", '$valorFacturado' ]}
        }},
        {$group: {_id: {_id1: '$_id1', numeroFra: '$numeroFra', fechaFact: '$fechaFact', contrato: '$contrato',
              codProcFact: '$codProcFact', codigoCiudadInterno: '$codigoCiudadInterno',
              nombreCliente: '$nombreCliente', apellidoCliente: '$apellidoCliente', direccion: '$direccion',
              nombreBarrio: '$nombreBarrio', nombreCiudad: '$nombreCiudad',
              descripcionServicio: '$descripcionServicio', periodo: '$periodo', totalFraAntesImptos: '$totalFraAntesImptos',
              totalFraDespuesImptos: '$totalFraDespuesImptos', saldoPendiente: '$saldoPendiente'},
                  valorAntesDeIVA: {$sum: '$valorAntesDeIVA'}, valorIVA: {$sum: '$valorIVA'}}},
        {$lookup: {from: 'clientes', localField: '_id.contrato', foreignField: 'contrato', as: 'cliente'}},
        {$unwind:"$cliente"},
        {$lookup: {from: 'procfacts', localField: '_id.codProcFact', foreignField: 'codProcFact', as: 'procfact'}},
        {$unwind:"$procfact"},

        {$lookup: {from: 'recursos', localField: 'cliente.dirmayor.ciudades.zonas.barrios.numeroDocumR', foreignField: 'numeroDocum', as: 'docrecurso'}},
        {$unwind:"$docrecurso"},

        {$project: {_id: {$concat: ['$_id.numeroFra', '$_id.descripcionServicio', '$_id.periodo']},
              fechaMov: '$procfact.pagueHasta', numeroFra: '$_id.numeroFra', fechaFact: '$_id.fechaFact',
              contrato: '$_id.contrato', codigoCiudadInterno: '$_id.codigoCiudadInterno', codBarrasRdo: '${fechaImpr}',
              numeroDocum: '$cliente.numeroDoc', saldoPendienteCl: '$cliente.saldoPendiente',
              diasMoraCl: '$cliente.diasMora', valorNC: '$cliente.cargoMensual',
              tipoGen: '$cliente.dirmayor.ciudades.zonas.barrios.descrRecursoR',
              envFraCorreo: '$cliente.envFraCorreo',
              descrDpto: '$docrecurso.telContacto',
              nombreCliente: '$_id.nombreCliente', apellidoCliente: '$_id.apellidoCliente', direccion: '$_id.direccion',
              nombreBarrio: '$_id.nombreBarrio', nombreCiudad: '$_id.nombreCiudad',
              descrRecurso: '$_id.descripcionServicio',
              agno: '$_id.periodo', valorAntesImptos: '$_id.totalFraAntesImptos',
              valorFactura: '$_id.totalFraDespuesImptos', saldoPendiente: '$_id.saldoPendiente',
              codProcFact: '$valorAntesDeIVA', idRangoFact: '$valorIVA',
              mes: { $add: [ '$valorAntesDeIVA', '$valorIVA' ]},
              valorFacturado: { $add: [ '$_id.saldoPendiente', '$_id.totalFraDespuesImptos' ]},
              cufe: {
                $dateToString: {
                  format: "%Y-%m-%d",
                  date: '$cliente.fechaPrimeraActivacion'
                }
              }
        }},
        ${argsBuscarSP}
        {$sort: {tipoGen: 1, nombreCiudad: 1, nombreBarrio: 1, direccion: 1, numeroFra: 1}},
      ]`}
      // console.log(argsBuscarFact)
      if(argsBuscarFact){
        let {data} = await this.props.allFactRtes.refetch(argsBuscarFact)
        listFactCsv = await data.allFactRtes
        // console.log(listFactCsv)
      }
      // console.log(listFactCsv)
      let txtString = ""
      txtString += 'fechaImpr;fechaFact;sucursal;numeroFra;contrato;fechaLimite;cedula;nombreCliente;apellidoCliente;'
      txtString += 'direccion;nombreBarrio;nombreCiudad;descripcionServicio;periodo;valorDetalleAntesDeIVA;valorDetalleIVA;totalDetalle;'
      txtString += 'saldoPendiente;totalFraAntesImptos;totalFraDespuesImptos;totalAPagar'
      if(this.props.empresa.empresaArchFE==="conectic"){
        txtString += ';Recauda;telContacto;PrimActivac'
      }

      txtString += "\r\n";
      for(let i=0; i<listFactCsv.length; i++){
        // if(listFactCsv[i].contrato==="9613"){
        //   console.log(listFactCsv[i], this.props.empresa.pagueHastaSegunSaldo)
        // }
        let fechaLimite = listFactCsv[i].fechaMov.substr(0,10)
        if(this.props.empresa.pagueHastaSegunSaldo){
          // let saldoPendiente = listFactCsv[i].saldoPendiente
          if(listFactCsv[i].saldoPendiente > (listFactCsv[i].valorNC * (this.props.empresa.numMesesParaPH - 1))){
            fechaLimite = "PAGO INMEDIATO"
          }
        }
        // if(listFactCsv[i].saldoPendiente>0){
        //   fechaLimite = "PAGO INMEDIATO"
        // }

        // let sucursal = ""
        // if(listFactCsv[i].nombreCiudad==="PASTO"){
        //   sucursal = "41"
        // }
        let sucursal = listFactCsv[i].codigoCiudadInterno
        txtString += listFactCsv[i].codBarrasRdo + ';' + listFactCsv[i].fechaFact.substr(0,10) + ';'
        txtString += sucursal + ';' + listFactCsv[i].numeroFra + ';'
        txtString += listFactCsv[i].contrato + ';' + fechaLimite + ';'
        txtString += listFactCsv[i].numeroDocum + ';'
        txtString += listFactCsv[i].nombreCliente + ';' + listFactCsv[i].apellidoCliente + ';'
        txtString += listFactCsv[i].direccion + ';' + listFactCsv[i].nombreBarrio + ';'
        txtString += listFactCsv[i].nombreCiudad + ';'
        txtString += listFactCsv[i].descrRecurso + ';' + listFactCsv[i].agno + ';'
        txtString += listFactCsv[i].codProcFact + ';' + listFactCsv[i].idRangoFact + ';'
        txtString += listFactCsv[i].mes + ';' + listFactCsv[i].saldoPendiente + ';'
        txtString += listFactCsv[i].valorAntesImptos + ';' + listFactCsv[i].valorFactura + ';'
        txtString += listFactCsv[i].valorFacturado
        if(this.props.empresa.empresaArchFE==="conectic"){
          let fechaPrimeraActivacion = listFactCsv[i].cufe?listFactCsv[i].cufe:""
          txtString += ';' + listFactCsv[i].tipoGen + ';' + listFactCsv[i].descrDpto + ';' + fechaPrimeraActivacion
        }
        
        txtString += "\r\n";
      }

      var blob = new Blob([txtString], {type: "text/plain;charset=utf-8"});
      saveAs(blob, nombreArch);

      document.body.style.cursor = 'default'
    }
  }

  handleImprimirTablaXls = (ev) => {
    var tableToExcel = (function() {
      var tmpElemento = document.createElement('a')
    //window.btoa => Encode a string in base-64
      var uri = 'data:application/vnd.ms-excel;base64,'
        , template = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
                            xmlns:x="urn:schemas-microsoft-com:office:excel">
                        <head>
                          <!--[if gte mso 9]>
                            <xml><x:ExcelWorkbook>
                                  <x:ExcelWorksheets>
                                    <x:ExcelWorksheet>
                                      <x:Name>{worksheet}</x:Name>
                                      <x:WorksheetOptions><x:DisplayGridlines/>
                                      </x:WorksheetOptions>
                                    </x:ExcelWorksheet>
                                  </x:ExcelWorksheets>
                                </x:ExcelWorkbook>
                            </xml>
                          <![endif]-->
                        </head>
                        <body><table>{table}</table></body>
                      </html>`
        , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
        , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
      return function(table, hoja) {
        if (!table.nodeType) table = document.getElementById(table)
        var ctx = {worksheet: hoja || 'Worksheet', table: table.innerHTML}
        tmpElemento.href = uri + base64(format(template, ctx))
        tmpElemento.download = 'resumenfact.xls';
        tmpElemento.click();
      }
    })()

    tableToExcel('tablaFras', 'facturas')
  }

  handleImprimirTablaPdf = (ev, argsDocum) => {
    var doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
    doc.setFontSize(14);
    doc.setFontType("bold");
    let texto1 = this.props.empresa.empresaRazonSocial
    let texto2 = "RESUMEN DE FACTURACION"
    // const fechaHoy = new Date()
    // let agnoHoy = fechaHoy.getFullYear()
    // let mesHoy = ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1))
    // mesHoy = agnoHoy + "-" + mesHoy
    // let mesMsg = ""
    // argsDocum.mes?mesMsg=argsDocum.mes:mesMsg=mesHoy
    var tit1Texto3 = document.getElementById("miListaP")
    // var tit2Texto3 = mesMsg
    // let texto3 = `${tit1Texto3.options[tit1Texto3.selectedIndex].text} - MES: ${tit2Texto3}`
    let texto3 = `${tit1Texto3.options[tit1Texto3.selectedIndex].text}`
    doc.text(texto1, 108, 20, 'center')
    doc.setFontSize(12);
    doc.text(texto2, 108, 30, 'center')
    doc.setFontSize(10);
    doc.text(texto3, 108, 40, 'center')

    var source = document.getElementById("tablaFras");
    doc.autoTable({startY: 55,
                    tableLineColor: "blue",
                    tableLineWidth: 0.1,
                    styles: {
                      // font: 'Calibri',
                      fontSize: 10,
                      lineColor: "black",
                      lineWidth: 0.1
                    },
                    headStyles: {
                      fillColor: "#bdc3c7",
                      textColor: "black",
                      fontSize: 12
                    },
                    bodyStyles: {
                      fillColor: "#E9E4F0",
                      textColor: "black"
                    },
                    alternateRowStyles: {
                      fillColor: "white",
                      textColor: "black"
                    },
                    html: source,
                    margin: {top: 10, left: 2, right: 2},})
    // let finalY = doc.previousAutoTable.finalY; //para traer posicion final de la tabla
    // doc.text("TOTAL", 50, finalY + 15);
    doc.autoPrint({variant: 'non-conform'});
    // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana // OJOOO YA NO FUNCIONA
    // => UTILIZAR
    const pdfBlob = doc.output('blob');
    const url = URL.createObjectURL(pdfBlob);
    window.open(url);
    // doc.save('resumenfact.pdf')
  }

  async UNSAFE_componentWillMount(){
    if(this.state.argsDocum.hastaF===""){
      const argsDocum = this.state.argsDocum
      const response = await this.props.fecha({
        variables: {}
      });
      const {fechaFechaHoy} = await response.data.fecha
      argsDocum['hastaF'] = fechaFechaHoy.substr(0,10)
      this.setState(argsDocum)
    }
  }

  async componentDidUpdate(prevProps, prevState){
    if(this.props.argsSelDpto.codigoCiudad!==undefined&&this.props.argsSelDpto.codigoCiudad!==""){
      let miLista = document.getElementById("miLista1");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoCiudad){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreCiudad'] = "Todas..."
        argsSelDpto['codigoCiudad'] = ""
        argsSelDpto['codigoCiudadInterno'] = ""
        argsSelDpto['codBarrasRdo'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoZona!==undefined&&this.props.argsSelDpto.codigoZona!==""){
      let miLista = document.getElementById("miLista2");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoZona){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreZona'] = "Todas..."
        argsSelDpto['codigoZona'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoBarrio!==undefined&&this.props.argsSelDpto.codigoBarrio!==""){
      let miLista = document.getElementById("miLista3");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoBarrio){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreBarrio'] = "Todos..."
        argsSelDpto['codigoBarrio'] = ""
        argsSelDpto['codigoTipoDocT'] = ""
        argsSelDpto['numeroDocumT'] = ""
        argsSelDpto['descrRecursoT'] = ""
        argsSelDpto['codigoTipoDocR'] = ""
        argsSelDpto['numeroDocumR'] = ""
        argsSelDpto['descrRecursoR'] = ""
        this.setState({argsSelDpto})
      }
    }

    if(this.state.stImprFact!==prevState.stImprFact){
      this.setState({stImprFact: false})
    }
  }

  render(){
    const {argsDocum, totFras, listFact, stImprFact, clientesFra} = this.state;
    const a050501 = this.props.autorizacUA.findIndex( autorizac => autorizac === "050501" );
    const a050505 = this.props.autorizacUA.findIndex( autorizac => autorizac === "050505" );
    const a050510 = this.props.autorizacUA.findIndex( autorizac => autorizac === "050510" );

    // const fechaHoy = new Date()
    // let agnoHoy = fechaHoy.getFullYear()
    // let mesHoy = ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1))
    // mesHoy = agnoHoy + "-" + mesHoy
    // let mesMsg = ""
    // argsDocum.mes?mesMsg=argsDocum.mes:mesMsg=mesHoy
    // // let imgIcon = "images/archivo_32.png"
    // console.log(this.props.list2)
    if(this.props.codigoCiudadUA!=="Todas..."){
      let dpto = document.getElementById("miLista");
      if(dpto){
        // console.log(this.props.list1)
        dpto.options.selectedIndex = 0
      }
    }

    let colecc = selDirmayor(this.props.list1, this.props.argsSelDpto, this.props.codigoCiudadUA)
    let listCiu = colecc.listCiu
    let listZon = colecc.listZon
    let listBar = colecc.listBar


    // let listCiu = [], listZon = [], listBar = []
    // listCiu.push({nombreCiudad: "Todas..."})
    // listZon.push({nombreZona: "Todas..."})
    // listBar.push({nombreBarrio: "Todos..."})
    // if(this.props.argsSelDpto._id){
    //   let miLista = document.getElementById("miLista");
    //   //Ciudades del Dpto seleccionado
    //   let indexSearchD = this.props.list1.findIndex(elementoD => elementoD._id===this.props.argsSelDpto._id)
    //   if(indexSearchD!==-1){
    //     let indexSearchC = -1, indexSearchZ = -1
    //     if(this.props.codigoCiudadUA==="Todas..."){
    //       listCiu = listCiu.concat(this.props.list1[indexSearchD].ciudades);
    //       miLista = document.getElementById("miLista1");
    //       let existe = "N"
    //       indexSearchC = listCiu.findIndex(elementoC => elementoC.codigoCiudad===miLista.options[miLista.selectedIndex].value)
    //       if(indexSearchC!==-1){
    //         existe = "S"
    //       }
    //       if(existe==="N"){
    //         miLista.options.selectedIndex = 0
    //       }
    //     }else{
    //       listCiu = this.props.list1[indexSearchD].ciudades.filter(elemento => elemento.codigoCiudad===this.props.codigoCiudadUA)
    //     }
    //     //Zonas de la Ciudad seleccionada
    //     miLista = document.getElementById("miLista1");
    //     indexSearchC = listCiu.findIndex(elementoC => elementoC.codigoCiudad===miLista.options[miLista.selectedIndex].value)
    //     if(indexSearchC!==-1){
    //       listZon = listZon.concat(listCiu[indexSearchC].zonas);
    //       miLista = document.getElementById("miLista2");
    //       let existe = "N"
    //       let indexSearchZ = listZon.findIndex(elementoZ => elementoZ.codigoZona===miLista.options[miLista.selectedIndex].value)
    //       if(indexSearchZ!==-1){
    //         existe = "S"
    //       }
    //       if(existe==="N"){
    //         miLista.options.selectedIndex = 0
    //       }
    //     }
    //     //Zonas de la Ciudad seleccionada
    //     miLista = document.getElementById("miLista2");
    //     indexSearchZ = listZon.findIndex(elementoZ => elementoZ.codigoZona===miLista.options[miLista.selectedIndex].value)
    //     if(indexSearchZ!==-1){
    //       for(let i=0; i<listZon[indexSearchZ].barrios.length; i++){
    //         listBar.push({codigoZona: listZon[indexSearchZ].codigoZona,
    //           nombreZona: listZon[indexSearchZ].nombreZona,
    //           codigoBarrio: listZon[indexSearchZ].barrios[i].codigoBarrio,
    //           nombreBarrio: listZon[indexSearchZ].barrios[i].nombreBarrio,
    //           codigoTipoDocT: listZon[indexSearchZ].barrios[i].codigoTipoDocT,
    //           numeroDocumT: listZon[indexSearchZ].barrios[i].numeroDocumT,
    //           descrRecursoT: listZon[indexSearchZ].barrios[i].descrRecursoT,
    //           codigoTipoDocR: listZon[indexSearchZ].barrios[i].codigoTipoDocR,
    //           numeroDocumR: listZon[indexSearchZ].barrios[i].numeroDocumR,
    //           descrRecursoR: listZon[indexSearchZ].barrios[i].descrRecursoR,
    //         })
    //       }
    //       miLista = document.getElementById("miLista3");
    //       let existe = "N"
    //       let indexSearchB = listBar.findIndex(elementoB => elementoB.codigoBarrio===miLista.options[miLista.selectedIndex].value)
    //       if(indexSearchB!==-1){
    //         existe = "S"
    //       }
    //       if(existe==="N"){
    //         miLista.options.selectedIndex = 0
    //       }
    //     }
    //   }
    // }else{
    //   if(this.props.argsSelDpto._id===""){
    //     let miLista = document.getElementById("miLista");
    //     miLista.options.selectedIndex = 0
    //     miLista = document.getElementById("miLista1");
    //     miLista.options.selectedIndex = 0
    //     miLista = document.getElementById("miLista2");
    //     miLista.options.selectedIndex = 0
    //     miLista = document.getElementById("miLista3");
    //     miLista.options.selectedIndex = 0
    //   }
    // }

    // console.log(listZon)
    let procMes = []
    this.props.list2.forEach((elemento, i) => {
      if(elemento.fechaCreate.substr(0, 10)>=argsDocum.desdeF&&elemento.fechaCreate.substr(0, 10)<=argsDocum.hastaF){
        procMes.push(elemento)
      }
    })
    // console.log(listFact)
    // let procMes = this.props.list2.filter(elemento => elemento.mes===mesMsg)
    // console.log(this.props.argsSelDpto, argsSelDpto)
    // console.log(stImprFact, imprFactCl)
    let listFactCl = []
    let imprFactCl = true
    if(stImprFact){
      // console.log("11")
      listFact.forEach((elemento, i) => {
        let indexSearch = clientesFra.findIndex( cliente => cliente.contrato===elemento.contrato )
        if(indexSearch===-1){
          imprFactCl = false
        }
        listFactCl.push({listFact: listFact[i], clientesFra: clientesFra[indexSearch]})
      })
      // console.log("22")
    }
    //     console.log(stImprFact, imprFactCl)
    // console.log(listFactCl)
    // console.log(this.props.argsBuscar)
    // console.log(this.props.empresa)
    // console.log(argsDocum)

    let permImpr = "Imprimir clientes que autorizaron envío de factura por correo"
    if(this.props.empresa.empresaArchFE==="codisert"){
      permImpr = "Imprimir clientes cargados con archivo csv"
    }
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
            <i className="large plus yellow icon"></i>
            Imprimir facturación
        </button>
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1">
              <div>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '40%'}}>
                      <h1 style={{color: '#2C7744'}}>Imprimir facturación</h1>
                        {/* <input type="radio" name="imprimir" value="uno" defaultChecked="true"  onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1em', fontWeight: 'bold'}}>&nbsp;Un solo archivo&nbsp;&nbsp;&nbsp;</label>
                        <input type="radio" name="imprimir" value="varios" onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1em', fontWeight: 'bold'}}>&nbsp;Un archivo por factura</label> */}
                    </div>
                    <div className="column" style={{width: '60%'}}>
                      <Form.Field>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkEnvFraCorreo" checked={argsDocum.checkEnvFraCorreo} onChange={this.handleChange}/>
                          &nbsp;&nbsp;{permImpr}
                        </p>
                      </Form.Field>
                    </div>

                    {/* <div className="column" style={{width: '40%'}}>
                      <p>
                        <span style={{background: '#7F7FD5', padding: '0.5em', color: 'white', fontSize: '1.2em'}} className='ui basic label'>
                          Seleccionar mes: &nbsp;&nbsp;
                          <span>
                            <input style={{color: '#302b63', fontSize: '2em', paddingright: '2.5em'}} type='month' defaultValue={mesHoy} name="mes" id="mes" onChange={this.handleChange}/>
                          </span>
                        </span>
                      </p>
                    </div> */}
                  </div>
                </div>
                <hr></hr>

                {/* <canvas id="barcodecanvasjs"  width="10" height="1"></canvas> */}
                {/* <svg id="barcodesvgjs"  width="10" height="1"></svg> */}
                {/* <img id="barcodeimgjs"/> */}

                {/* <img width="300" height="200" src={nuevaImg} alt="imagen"></img> */}

                <div className="ui four column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '25%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Procesos fact desde
                      </p>
                      <Form.Field>
                        <input style={this.props.styles.input} type='date' name="desdeF" id="desdeF" value={argsDocum.desdeF} onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '25%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Hasta
                      </p>
                      <Form.Field>
                        <input style={this.props.styles.input} type='date' name="hastaF" id="hastaF" value={argsDocum.hastaF} onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '25%'}}>
                      <Form.Field>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkSaldoPendiente" checked={argsDocum.checkSaldoPendiente} onChange={this.handleChange}/>
                          &nbsp;&nbsp;Imprimir Saldo mayor a
                        </p>
                        <input value={argsDocum.saldoPendiente} type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="saldoPendiente" id="saldoPendiente" placeholder='Saldo pendiente' onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '25%'}}>
                      <Form.Field>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkMora" checked={argsDocum.checkMora} onChange={this.handleChange}/>
                          &nbsp;&nbsp;NO imprimir mora mayor a
                        </p>
                        <input value={argsDocum.diasMora} type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="diasMora" id="diasMora" placeholder='Días en mora' onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Procesos de facturación
                </p>
                <Form.Field>
                  <Lista styles={this.props.styles} list={procMes} handleChange={this.handleChange}/>
                  {/* <input style={this.props.styles.input} autoComplete="off" name="observaciones" id="observaciones" value={observaciones} onChange={(ev)=>this.handleChange(ev)} placeholder='observaciones'/> */}
                </Form.Field>
                <hr></hr>

                {this.props.empresa.empresaArchFE==="codisert" &&
                  <div>
                    <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Estado
                    </p>
                    <Form.Field>
                      <ListaEst styles={this.props.styles} list={this.props.list3} argsDocum={argsDocum} handleChange={this.handleChange}/>
                    </Form.Field>
                    <hr></hr>
                  </div>
                }

                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Departamento
                        </label>
                        <ListaDe list={this.props.list1} styles={this.props.styles}
                          handleLista={this.props.handleLista} codigoCiudadUA={this.props.codigoCiudadUA}
                          codigoDptoUA={this.props.codigoDptoUA}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Ciudad
                        </label>
                        <ListaCi list={listCiu} styles={this.props.styles}
                          handleLista1={this.props.handleLista1} argsSelDpto={this.props.argsSelDpto}
                          codigoCiudadUA={this.props.codigoCiudadUA}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Zona
                        </label>
                        <ListaZo list={listZon} styles={this.props.styles} handleLista2={this.props.handleLista2} argsSelDpto={this.props.argsSelDpto}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Barrio
                        </label>
                        <ListaBa list={listBar} styles={this.props.styles} handleLista3={this.props.handleLista3} argsSelDpto={this.props.argsSelDpto}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Total facturas:&nbsp;{totFras}&nbsp;&nbsp;&nbsp;&nbsp;
                  {a050501!==-1 &&
                    <a className='ui large label' style={this.props.styles.styTableInf} onClick={(ev)=>this.handleImprimirTablaXls(ev)}><i className='file excel outline icon'></i>Excel</a>
                  }
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  {a050505!==-1 &&
                    <a className='ui large label' style={this.props.styles.styTableInf} onClick={(ev)=>this.handleImprimirTablaPdf(ev, argsDocum)}><i className='file pdf outline icon'></i>Pdf</a>
                  }
                </p>

                {this.props.empresa.modeloFactura!=="3" &&
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum)} fluid>
                            VER RESUMEN EN PANTALLA
                        </Button>
                      </div>
                      <div className="column" style={{width: '50%'}}>
                        {a050510!==-1 &&
                          <Button name="pdf" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum)} fluid>
                            GENERAR FACTURAS EN PDF
                          </Button>
                        }

                        {/* {(stImprFact&&imprFactCl) && */}
                        {(imprFactCl) &&
                          <ImprFact listFactCl={listFactCl} list2={this.props.list2} list={this.props.list}
                            empresa={this.props.empresa} stImprFact={stImprFact}/>
                        }
                      </div>
                    </div>
                  </div>
                }
                {this.props.empresa.modeloFactura==="3" &&
                  <div className="ui three column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '33%'}}>
                        <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum)} fluid>
                            VER RESUMEN EN PANTALLA
                        </Button>
                      </div>
                      <div className="column" style={{width: '33%'}}>
                        <Button id="csv" name="csv" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmitCsv(ev, argsDocum)} fluid>
                            ARCHIVO CSV
                        </Button>
                      </div>
                      <div className="column" style={{width: '34%'}}>
                        {a050510!==-1 &&
                          <Button name="pdf" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum)} fluid>
                            GENERAR FACTURAS EN PDF
                          </Button>
                        }

                        {/* {(stImprFact&&imprFactCl) && */}
                        {(imprFactCl) &&
                          <ImprFact listFactCl={listFactCl} list2={this.props.list2} list={this.props.list}
                            empresa={this.props.empresa} stImprFact={stImprFact}/>
                        }
                      </div>
                    </div>
                  </div>
                }

                <hr></hr>
                <table id="tablaFras" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className=''># Factura</th>
                      <th className=''>Contrato</th>
                      <th className=''>Barrio</th>
                      <th className=''>Fecha</th>
                      <th className=''>Año</th>
                      <th className=''>mes</th>
                      <th className='right aligned'>$ antes de imptos</th>
                      <th className='right aligned'>$ despues de imptos</th>
                      <th className='right aligned'>$ Total Factura</th>
                    </tr>
                  </thead>
                  <ListaFact list={listFact}/>
                </table>
              </div>
            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allServicios, {name:'allServicios', options: (props) => {return {variables: {}}}}),
  // graphql(queries.query.allFacturacion, {name:'allFacturacion', options: (props) => {return {variables: {agno: "agnoHoy", mes: mesHoy}}}}),
  // graphql(queries.query.allFacturacion, {name:'allFacturacion', options: (props) => {return {variables: {agno: "2017", mes: "01"}}}}),
  graphql(queries.query.allFacturacion, {name:'allFacturacion', options: (props) => {return {variables: {fechaMov: { $gte: "2019-04-08", $lte: "2019-04-08" }}}}}),
  graphql(queries.query.allFactRtes, {name:'allFactRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {fechaFact: new Date("2018-04-07")}}]`}}}}),

  graphql(queries.query.allCliBasico, {name:'allCliBasico', options: (props) => {return {variables: {contrato: "XYZ321"}}}}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(FactIFact2)
